import { useTranslation } from "react-i18next";
import Reveal from "@/components/base/Reveal";

const ITEMS = [
  { icon: "ri-leaf-line", key: "vegetarian" },
  { icon: "ri-bear-smile-line", key: "pet" },
  { icon: "ri-translate-2", key: "languages" },
  { icon: "ri-sofa-line", key: "intimate" },
  { icon: "ri-shopping-bag-3-line", key: "pickup" },
  { icon: "ri-heart-pulse-line", key: "allergies" },
];

export default function BeforeVisit() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-3xl px-5 md:px-10">
        <Reveal>
          <h2 className="text-center font-heading text-3xl leading-tight text-foreground-50 md:text-5xl">
            {t("beforeVisit.title")}
          </h2>
          <ul className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2">
            {ITEMS.map((item) => (
              <li
                key={item.key}
                className="flex items-start gap-4 rounded-lg border border-background-300/50 bg-background-100 p-5"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center text-primary-500">
                  <i className={`${item.icon} text-2xl`} aria-hidden="true" />
                </span>
                <span className="font-body text-base leading-relaxed text-secondary-500">
                  {t(`beforeVisit.items.${item.key}`)}
                </span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}